import Styles from "../AnonForms.module.css";

function InjuredInput({ 
  injured,
  injuredDesc,
  createInput
}) {
  const injuredLabel = `${injuredDesc}`;

  return (
    <div className={Styles.groupedInputs}>
      <div className={Styles.labelContainer}>
        <p className={Styles.injuredLabel}> {injuredLabel} </p>
      </div>
      {createInput(injured.firstName, "100%", Styles.anonInput)}
      {createInput(injured.lastName, "100%", Styles.anonInput)}
    </div>
  );
}

export default InjuredInput;
